import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstant } from 'src/app/helper/class/app-constant';
import { AuthService } from 'src/app/helper/service/auth.service';
import { SettingsService } from 'src/app/helper/service/settings.service';

import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss'],
  standalone: true,
  imports: [RouterOutlet]
})
export class AuthLayoutComponent implements OnInit {
  title = '';
  logo = '';
  theme_color = '#417adf';
  theme = `background-color: ${this.theme_color} `;
  constructor(
    private router: Router,
    private settingsService: SettingsService,
  ) {}

  ngOnInit(): void {
    this.logo =
      this.settingsService.snapshot?.siteLogo || 'assets/images/logo.png';
    this.title = this.settingsService.snapshot?.siteName || 'Organization';
    // this.theme_color =
    //   this.settingsService.snapshot?.themeColor || this.theme_color;
    // this.theme = `background-color: ${this.theme_color} `;
    if (this.router.url.includes('pw')) {
      this.theme = `background-color: #1c6485 `;
    }
  }
}
